// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-903ac390]:-moz-read-only {\n  white-space: nowrap;\n}\n[data-v-903ac390]:read-only {\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
